<template>
  <div>
    <b-card border-variant="dark">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <b-card-header>
          <b-card-title>تاریخچه اطلاعات</b-card-title>
        </b-card-header>
        <b-button variant="outline-primary" class="btn-icon" @click="showPhysicalInfoForm = true">
          <feather-icon icon="PlusIcon" style="margin-left: 5px" />
          <span>افزودن اطلاعات جسمانی</span>
        </b-button>
      </div>
      <div class="overflow-scroll" style="height: 350px">
        <b-table
            bordered
            :items="logs"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
        >
          <template #cell(lactationType)="data">
            <b-badge :variant="enums('Lactation', 'value', data.item.lactationType, 'badge')">
              {{ enums('Lactation', 'value', data.item.lactationType, 'text') }}
            </b-badge>
          </template>
          <template #cell(date)="data">
            {{ data.value | date }}
          </template>
        </b-table>
      </div>
    </b-card>
   <user-physical-report :UserId="userId"></user-physical-report>
    <b-card
        border-variant="dark"
        title="بیماری ها"
    >
      <b-card-body>
        <template v-for="ill in illnesses">
          <b-badge
              variant="light-info"
              class="ml-1"
          >
            {{ ill }}
          </b-badge>
        </template>
      </b-card-body>
    </b-card>
    <user-hate-food :UserId="userId"></user-hate-food>
    <b-card
      border-variant="dark"
      title="تغییرات وزنی"
    >
      <div
        class="d-inline-block"
      >
        <b-input-group
          append="وزن اخیر"
          class="input-group-merge"
          style="width:130px"
        >
          <b-form-input
            v-model="numberOfWeights"
            placeholder="10"
          />
        </b-input-group>
      </div>
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        class="d-inline-block ml-1"
        variant="warning"
        @click="updateWeightHistory()"
      >فیلتر
      </b-button>
      <b-card-body class="text-center">
        <vue-apex-charts
          v-if="showAxis"
          type="line"
          height="400"
          :options="apexChatData.lineChartSimple.chartOptions"
          :series="apexChatData.lineChartSimple.series"
        />
      </b-card-body>
    </b-card>
    <add-physical-info-form :show.sync="showPhysicalInfoForm" :data="latestInfo" :user-id="userId" @update="get" />
  </div>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import VueApexCharts from 'vue-apexcharts'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import apexChatData from './apexChartData'
import AddPhysicalInfoForm from "@/views/menu/user/addPhysicalInfoForm.vue";
import userPhysicalReport from '@/tools/userPhysicalReport.vue'
import userHateFood from '@/tools/userHateFood.vue'
export default {
  name: 'UserPhysicalInfo',
  components: {
    AppTimeline,
    AppTimelineItem,
    VueApexCharts,
    VuePerfectScrollbar,
    AddPhysicalInfoForm,
    userPhysicalReport,
    userHateFood
  },
  props: {
    userId: { type: [Number, String], default: null },
  },
  data() {
    return {
      logs: [],
      apexChatData,
      illnesses: ['ش', 'سسسسسس', 'ببببب'],
      filterOptions: {
        UserId: this.userId,
        Page: 1,
        PerPage: 20,
      },
      dataIsReceived: false,
      showAxis: false,
      numberOfWeights: 10,
      totalRow: null,
      latestInfo: null,
      fields: [
        {
          key: 'date',
          label: 'تاریخ',
          variant: 'secondary',
          stickyColumn: true,
          isRowHeader: true
        },
        {
          key: 'weight',
          label: 'وزن',
        },
        {
          key: 'height',
          label: 'قد',
        },
        {
          key: 'age',
          label: 'سن',
        },
        {
          key: 'bmi',
          label: 'bmi',
        },
        {
          key: 'calorie',
          label: 'کالری جاری',
        },
        {
          key: 'dietDifficulty',
          label: 'سختی رژیم',
          thStyle: { width: "130px" },
        },
        {
          key: 'goal',
          label: 'وزن هدف',
        },
        {
          key: 'lactationType',
          label: 'دوران شیردهی',
        },
        {
          key: 'wrist',
          label: 'دور مچ',
        },
        {
          key: 'gender',
          label: 'جنسیت',
        },
        {
          key: 'activityLevel',
          label: 'سطح فعالیت',
        },
        {
          key: 'belly',
          label: 'دور شکم',
        },
        {
          key: 'waist',
          label: 'دور کمر',
        },
        {
          key: 'chest',
          label: 'دور سینه',
        },
        {
          key: 'arm',
          label: 'دور بازو',
        },
        {
          key: 'hip',
          label: 'دور باسن',
        },
        {
          key: 'thigh',
          label: 'دور ران',
        },
      ],
      showPhysicalInfoForm: false,
    }
  },
  created() {
    this.get()
    this.getIllness()
  },
  methods: {
    get() {
      this.getBodyHistories(this.filterOptions).then(bodyHistories => {
        this.logs = []
        this.extractBodyHistoryLog(bodyHistories)
        this.extractWeightHistoryLog(bodyHistories)
        this.dataIsReceived = true
        this.showAxis = true
      })
    },
    updateWeightHistory() {
      let page = 1
      const result = []
      const promises = []
      let { numberOfWeights } = this
      this.showAxis = false
      if (this.numberOfWeights > this.totalRow) {
        numberOfWeights = this.totalRow
      }
      if (this.numberOfWeights % 50 >= 0) {
        page = (((numberOfWeights) / 50) + 1).toFixed(0)
      } else page = (numberOfWeights / 50).toFixed(0)

      for (let i = 1; i <= page; i += 1) {
        promises.push(this.getBodyHistories({ Page: i, UserId: this.userId, PerPage: 50 }))
      }
      Promise.all(promises).then(bodyHistories => {
        bodyHistories.forEach(bodyHistory => {
          result.push(...bodyHistory)
        })
        this.extractWeightHistoryLog(result.splice(1, numberOfWeights))
        this.showAxis = true
      })
    },
    updateBodyHistory() {
      if (this.totalRow === this.logs.length) return true
      this.filterOptions.Page += 1
      this.getBodyHistories(this.filterOptions).then(bodyHistories => {
        this.extractBodyHistoryLog(bodyHistories)
        this.dataIsReceived = true
      })
    },
    extractBodyHistoryLog(bodyHistories) {
      bodyHistories.forEach(bodyHistory => {
        let item = {
          date: bodyHistory.Date,
          weight: bodyHistory.Weight.toFixed(2),
          height: bodyHistory.Height,
          age: (Number(this.$moment().format('YYYY')) - Number(bodyHistory.BirthYear)),
          bmi: bodyHistory.Bmi,
          calorie: bodyHistory.CurrentCalorie,
          dietDifficulty: this.enums('DietDifficulty', 'value', bodyHistory.DietDifficulty, 'text'),
          goal: bodyHistory.GoalWeight,
          lactationType: bodyHistory.LactationType,
          wrist: bodyHistory.Wrist,
          gender: this.enums('Gender', 'value', bodyHistory.Gender, 'text'),
          activityLevel: this.enums('ActivityLevel', 'value', bodyHistory.ActivityLevel, 'text'),
          chest: bodyHistory.Chest,
          belly: bodyHistory.Belly,
          arm: bodyHistory.Arm,
          waist: bodyHistory.Waist,
          hip: bodyHistory.Hip,
          thigh: bodyHistory.Thigh,
        }
        this.logs.push(item)
      })
    },
    extractWeightHistoryLog(bodyHistories) {
      this.apexChatData.lineChartSimple.series[0].data = []
      this.apexChatData.lineChartSimple.chartOptions.xaxis.categories = []
      bodyHistories.reverse().forEach(bodyHistory => {
        this.apexChatData.lineChartSimple.series[0].data.push(bodyHistory.Weight.toFixed(2))
        this.apexChatData.lineChartSimple.chartOptions.xaxis.categories.push(this.$moment(bodyHistory.Date).format('jM-jDD'))
      })
    },
    getBodyHistories(filterOptions) {
      return new Promise(resolve => {
        this.$http.post(this.$api.user.bodyHistory, filterOptions).then(bodyHistories => {
          this.totalRow = bodyHistories.totalRow
          this.latestInfo = bodyHistories.data.length && bodyHistories.data[0] || null
          resolve(bodyHistories.data)
        })
      })
    },
    makeToast(variant = null) {
      this.$bvToast.toast('تغییرات وزنی', {
        title: `
        حداکثر تعداد تغییرات وزنی این کابر
        ${this.totalRow}
        `,
        variant,
        solid: true,
        toaster: 'b-toaster-bottom-right',
      })
    },
    getIllness() {
      this.$http.post(this.$api.UserSickness.getlist, { UserId: this.userId }).then(illness => {
        this.illnesses = illness.data.map(ill => ill.Title)
      })
    },
  },
}
</script>

<style scoped>
.scroll-area {
  margin: auto;
  height: 300px;
}
</style>
